import './index.scss';

export default function Footer() {
  return (
    <footer className="bg-black footerPage">
      <div className="container footer-container">
        <div className="mb-2 mb-md-0">
          © {new Date().getFullYear()} Fuzzy Score
        </div>
        <div>
          <a
            href="https://www.linkedin.com/in/isa-reinert-6b960826/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white me-3"
            aria-label="LinkedIn profile"
          >
            <i className="bi bi-linkedin" style={{fontSize: '1.5rem'}} />
          </a>
          <a
            href="https://www.github.com/reinertisa"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white"
            aria-label="LinkedIn profile"
          >
            <i className="bi bi-github" style={{fontSize: '1.5rem'}} />
          </a>
        </div>
      </div>
    </footer>
  );
}
